import { isEmpty } from "lodash";

/**
 * Trims the input of newlines after the second subsequent newline.
 *
 * @param input the input string.
 * @return the trimmed output.
 */
export const trimNewlinesAfterTwoSubsequentMatches = (input: string): string => {
  if (isEmpty(input)) {
    return "";
  }

  const regex = /(\n{2,})/gm;
  return input.replace(regex, "\n\n");
};
